$(document).ready(function(){
  
// $(document).on("click",".cl-po--swatch-item .cl-po--swatch",function() {
//    console.log("click working") ;


// });


  
  // BIS trigger click
  // $(".trigger_to_bis").click(function() {
  //     // console.log("Clicked");
  //     $(".BIS_trigger").trigger("click");
  // });
// =============================
$(document).on('click', '.cart__remove', function(e){
    var obj = $(this);
    e.preventDefault();
    e.stopPropagation();         
    var productId =  $(this).parent().closest('.cart__item').attr('data-key');
    // console.log("productId", productId );
      // var ID = productId.substring(0, 14);
      // console.log("ID",  ID);
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: productId
        },
        success: function (data){
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function(cart){
                  // console.log("success-cart" , cart )
                    var item_count = cart['item_count'];
                    var sub_total_price = cart['items_subtotal_price'];
                    var total_price = cart['total_price'];
                  // console.log("item_count" , item_count);
                  // console.log("item_count" , sub_total_price);
                  // console.log("item_count" , total_price);                   
                    if ( item_count == 0 ) {
                      // console.log("cart-empty")
                      $(".cart-total_price").html(theme.Currency.formatMoney(total_price, theme.settings.moneyFormat));
                      $(obj).parents(".cart__page").remove();
                      $(obj).parents(".drawer__inner").remove();
                      $(".cart-link__bubble").hide();                      
                      $(".cart-page-empty").css("display", "block");
                      $(".drawer__cart-empty").css("display", "block");    
                    } else {
                      $(".cart_subtotal_price strong").html(theme.Currency.formatMoney(sub_total_price, theme.settings.moneyFormat) );
                      $(".cart__item-subtotal div[data-subtotal]").html(theme.Currency.formatMoney(total_price, theme.settings.moneyFormat));
                      $(".cart-total_price").html(theme.Currency.formatMoney(total_price, theme.settings.moneyFormat));
                      $(".cart-link__bubble").html(item_count);
                      // console.log("thhis-obj", obj); 
                      $(obj).parent().closest('.cart__item').remove();
                    }
                }
            });
        }
    });
});
  


  // ============================================================
   if($(".quiz-form").find('.note--success').length !== 0){
          $(".quiz-step").hide();
            return false
        }
  
      var width = 7;
      function next() {
        var elem = $(".quiz-progress_bar .quiz-progress");
          if (width < 100) {
            width+=7.5;
          
            $(elem).css("width", width+"%");  
          }  
      }
        function back() {
        var elem = $(".quiz-progress_bar .quiz-progress");
          if (width < 100) {
            width-=7.5;
            $(elem).css("width", width+"%");  
          }  
      }

   var currentStep = 0;
   var form = $('#contact_form');
   var steps = form.find('.quiz-step');
   var step = form.find('.quiz-step:first');
   steps.each(function(e) {   
        if (e != 0){ $(this).hide();}           
    });
    step.show();
   
   $('.quiz-next-button').click(function() {
    var flg = 0;
    if(currentStep == 0){
      if($('[name="contact[photovoltaik]"]').val() == 'freilandfläche' || $('[name="contact[photovoltaik]"]').val() == 'sonstiges'){
        var flg = 1;
      }
    } 

    if(flg == 1) {
      width = 60;
      currentStep = 7;
      currentStep++;  
      showStep(currentStep);
      next();
    } else {
     if (validateStep(currentStep)) {
        var att_dis = $(this).parents(".quiz-step").find('select option:selected').is(':disabled');
        if(att_dis == true){
          return false
        }else{
          currentStep++;  
          showStep(currentStep);
          next();
        }                
     } 
    }
    
  });
   
  $('.quiz-back-button').click(function() {

    var flg1 = 0;
    if(currentStep == 8){
      if($('[name="contact[photovoltaik]"]').val() == 'freilandfläche' || $('[name="contact[photovoltaik]"]').val() == 'sonstiges'){
        var flg1 = 1;
      }
    } 
    if(flg1 == 1){
      width = 14.5;
      currentStep = 1;
      currentStep--;
      showStep(currentStep);
      back();  
    } else {
     currentStep--;
     showStep(currentStep);
     back(); 
    }
  });

  function showStep(stepIndex) {
    steps.hide();
    steps.eq(stepIndex).show();
    // console.log("stepIndex" , stepIndex)
    if (stepIndex === 0) {
      $('.quiz-back-button').css("opacity" , "0");
    } else {
      $('.quiz-back-button').css("opacity" , "1");
    }
    
    if (stepIndex === steps.length - 1) {
      $('.quiz-next-button').css("opacity" , "0");
    } else {
      $('.quiz-next-button').css("opacity" , "1");
    }
  }

  function validateStep(stepIndex) {
    var isValid = true;
    var currentStepForm = steps.eq(stepIndex).find('input, select');
    
    currentStepForm.each(function() {
      // console.log("each", this)
      var att_dis = $(this).find('option:selected').is(':disabled');
      // console.log("check-attibute", att_dis);
      // console.log(this.checkValidity());
  
      if (!this.checkValidity()) {    

      $(this).parents(".quiz-content").find(".error-message").removeClass("hide");
      // console.log("if-this", this)
      isValid = false;
      return false;
      } else {
              if(att_dis == true) {
              $(this).parents(".quiz-content").find(".error-message").removeClass("hide");
              return false;
              // console.log("secound if")
              }
              $(this).parents(".quiz-content").find(".error-message").addClass("hide");
              // console.log("else-this", this)
      }
    });  
    return isValid;
  }
  // on change replace image src
    $('.form-vertical .input-full').on('change', function() {
      // console.log(this);
      var src = $(this).find('option:selected').attr('data-imgsrc');
      // console.log(src);
      $(this).parents(".quiz-content").find(".quiz-images img").attr("src" , src);
    });
});